import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=765fea9a&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
import style0 from "./Shop.vue?vue&type=style&index=0&id=765fea9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765fea9a",
  null
  
)

export default component.exports